import { connect } from 'react-redux'

import User from './User'
import { fetch as fetchUser } from '@src/redux/modules/user'
import { getUsers } from '@src/redux/modules/entities'

const mapStateToProps = (state, ownProps) => {
  const { userId } = ownProps.params
  const users = getUsers(state)
  const user = users[userId]

  return {
    userId: parseInt(userId),
    user
  }
}

const mapDispatchToProps = {
  fetchUser
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(User)



// WEBPACK FOOTER //
// ./src/screens/App/screens/User/UserContainer.js